<i
  class="fas sortArrow sortable-column-icon "
  [ngClass]="{
    'fa-chevron-up': sortOrder === 1,
    'fa-chevron-down': sortOrder === -1,
    '': sortOrder === 0
  }"
>
</i>
